import { IUser } from '@/models';


export const getUserFullName = (user: IUser): string => {
    const fio = user !== null && user !== undefined ? `${user.last_name || ''} ${user.first_name || ''} ${user.middle_name || ''}` : ''
    return fio !== '' ? fio : user && user.hasOwnProperty('email') ? user.email : ''
}